import { ResponseGraphics as Graphics } from '../../../../models/common-payments';
import { AmountsBarGraph } from '../amount-graphic';
import { BanksPieChart } from '../banks-pie-chart';
import {
	HeaderContainer,
	SectionContainer,
	SectionContent,
	SectionDate,
	SectionHeader,
	SectionTitle,
} from './styles';

interface QuickTransferHeaderProps {
	data?: Graphics;
	loading?: boolean;
}

const BusinessTransferHeader = ({ data, loading }: QuickTransferHeaderProps) => {
	const COLORS = ['#646174', '#838190', '#A2A0AC', '#C1C0C7', '#E0DFE3'];

	return (
		<HeaderContainer>
			<SectionContainer>
				<SectionHeader>
					<SectionTitle>Monto recaudado</SectionTitle>
					<SectionDate>Últimas 24 horas</SectionDate>
				</SectionHeader>

				<SectionContent>
					<AmountsBarGraph data={data?.amounts} barColor="#646174" tooltipColor="#e8e7eb" />
				</SectionContent>
			</SectionContainer>

			<SectionContainer>
				<SectionHeader>
					<SectionTitle>Cobros exitosos por banco</SectionTitle>
					<SectionDate>Últimas 24 horas</SectionDate>
				</SectionHeader>

				<SectionContent>
					<BanksPieChart data={data} colors={COLORS} tooltipColor="#e8e7eb" loading={loading} />
				</SectionContent>
			</SectionContainer>
		</HeaderContainer>
	);
};

export { BusinessTransferHeader };
